export const OCC_ENDPOINTS = {
  orderDocuments: 'current-user/orderDocuments',
  getOrderDocument: 'current-user/orderDocuments/${documentId}/file',
  personalManager: 'personal-manager/${userId}',
  approvePersonalManager: 'personal-manager/approve/${uid}',
  revokePersonalManager: 'personal-manager/revoke/${uid}',
  deletePersonalManager: 'personal-manager/delete/${uid}',
  personalManagers: 'personal-manager/list',
  bonusHistory: 'current-user/bonus-history',
  bonusStatus: 'current-user:calculateLoyaltyStatus',
  benefitSplitLimits: 'foreman/benefit-split-limits',
  promocodes: 'foreman/promocodes',
};
